Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isSameDay;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isSameDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
  return a.isSame(b, 'day');
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/lib/utils/isSameDay.js
 ** module id = 802
 ** module chunks = 1
 **/